/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateMealCommand } from '../model/createMealCommand';
import { CreateMealCommandResult } from '../model/createMealCommandResult';
import { DeleteMealCommand } from '../model/deleteMealCommand';
import { DeleteMealCommandResult } from '../model/deleteMealCommandResult';
import { GetMealQueryResult } from '../model/getMealQueryResult';
import { GetMealScheduleQueryResult } from '../model/getMealScheduleQueryResult';
import { GetMealsQueryResult } from '../model/getMealsQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';
import { MealsSortSpecification } from '../model/mealsSortSpecification';
import { ResourceScopeType } from '../model/resourceScopeType';
import { TrackMealCommand } from '../model/trackMealCommand';
import { UpdateMealCommand } from '../model/updateMealCommand';
import { UpdateMealVisibilityCommand } from '../model/updateMealVisibilityCommand';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MealsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mealsCreatePost(body?: CreateMealCommand, observe?: 'body', reportProgress?: boolean): Observable<CreateMealCommandResult>;
    public mealsCreatePost(body?: CreateMealCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateMealCommandResult>>;
    public mealsCreatePost(body?: CreateMealCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateMealCommandResult>>;
    public mealsCreatePost(body?: CreateMealCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CreateMealCommandResult>('post',`${this.basePath}/Meals/Create`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all meals 
     * UserUid gets all meals with filter
     * @param filterMinEnergyValue 
     * @param filterMaxEnergyValue 
     * @param filterChoices 
     * @param filterTags 
     * @param filterCreatedByUserUids 
     * @param filterTeamUid 
     * @param filterScopeType 
     * @param inMealLibrary 
     * @param sort 
     * @param bundleUid 
     * @param pageNumber 
     * @param pageSize 
     * @param searchText 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mealsGet(filterMinEnergyValue?: number, filterMaxEnergyValue?: number, filterChoices?: Array<string>, filterTags?: Array<string>, filterCreatedByUserUids?: Array<string>, filterTeamUid?: string, filterScopeType?: ResourceScopeType, inMealLibrary?: boolean, sort?: Array<MealsSortSpecification>, bundleUid?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'body', reportProgress?: boolean): Observable<GetMealsQueryResult>;
    public mealsGet(filterMinEnergyValue?: number, filterMaxEnergyValue?: number, filterChoices?: Array<string>, filterTags?: Array<string>, filterCreatedByUserUids?: Array<string>, filterTeamUid?: string, filterScopeType?: ResourceScopeType, inMealLibrary?: boolean, sort?: Array<MealsSortSpecification>, bundleUid?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetMealsQueryResult>>;
    public mealsGet(filterMinEnergyValue?: number, filterMaxEnergyValue?: number, filterChoices?: Array<string>, filterTags?: Array<string>, filterCreatedByUserUids?: Array<string>, filterTeamUid?: string, filterScopeType?: ResourceScopeType, inMealLibrary?: boolean, sort?: Array<MealsSortSpecification>, bundleUid?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetMealsQueryResult>>;
    public mealsGet(filterMinEnergyValue?: number, filterMaxEnergyValue?: number, filterChoices?: Array<string>, filterTags?: Array<string>, filterCreatedByUserUids?: Array<string>, filterTeamUid?: string, filterScopeType?: ResourceScopeType, inMealLibrary?: boolean, sort?: Array<MealsSortSpecification>, bundleUid?: string, pageNumber?: number, pageSize?: number, searchText?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {














        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterMinEnergyValue !== undefined && filterMinEnergyValue !== null) {
            queryParameters = queryParameters.set('Filter.MinEnergyValue', <any>filterMinEnergyValue);
        }
        if (filterMaxEnergyValue !== undefined && filterMaxEnergyValue !== null) {
            queryParameters = queryParameters.set('Filter.MaxEnergyValue', <any>filterMaxEnergyValue);
        }
        if (filterChoices) {
            filterChoices.forEach((element) => {
                queryParameters = queryParameters.append('Filter.Choices', <any>element);
            })
        }
        if (filterTags) {
            filterTags.forEach((element) => {
                queryParameters = queryParameters.append('Filter.Tags', <any>element);
            })
        }
        if (filterCreatedByUserUids) {
            filterCreatedByUserUids.forEach((element) => {
                queryParameters = queryParameters.append('Filter.CreatedByUserUids', <any>element);
            })
        }
        if (filterTeamUid !== undefined && filterTeamUid !== null) {
            queryParameters = queryParameters.set('Filter.TeamUid', <any>filterTeamUid);
        }
        if (filterScopeType !== undefined && filterScopeType !== null) {
            queryParameters = queryParameters.set('Filter.ScopeType', <any>filterScopeType);
        }
        if (inMealLibrary !== undefined && inMealLibrary !== null) {
            queryParameters = queryParameters.set('InMealLibrary', <any>inMealLibrary);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('Sort', <any>element);
            })
        }
        if (bundleUid !== undefined && bundleUid !== null) {
            queryParameters = queryParameters.set('BundleUid', <any>bundleUid);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', <any>searchText);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetMealsQueryResult>('get',`${this.basePath}/Meals`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param selectedDateLocal 
     * @param userUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mealsMealScheduleGet(selectedDateLocal?: string, userUid?: string, observe?: 'body', reportProgress?: boolean): Observable<GetMealScheduleQueryResult>;
    public mealsMealScheduleGet(selectedDateLocal?: string, userUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetMealScheduleQueryResult>>;
    public mealsMealScheduleGet(selectedDateLocal?: string, userUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetMealScheduleQueryResult>>;
    public mealsMealScheduleGet(selectedDateLocal?: string, userUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (selectedDateLocal !== undefined && selectedDateLocal !== null) {
            queryParameters = queryParameters.set('SelectedDateLocal', <any>selectedDateLocal);
        }
        if (userUid !== undefined && userUid !== null) {
            queryParameters = queryParameters.set('UserUid', <any>userUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetMealScheduleQueryResult>('get',`${this.basePath}/Meals/MealSchedule`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mealsPatch(body?: UpdateMealVisibilityCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public mealsPatch(body?: UpdateMealVisibilityCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public mealsPatch(body?: UpdateMealVisibilityCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public mealsPatch(body?: UpdateMealVisibilityCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('patch',`${this.basePath}/Meals`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mealsTrackPost(body?: TrackMealCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public mealsTrackPost(body?: TrackMealCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public mealsTrackPost(body?: TrackMealCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public mealsTrackPost(body?: TrackMealCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Meals/Track`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mealsUidDelete(uid: string, body?: DeleteMealCommand, observe?: 'body', reportProgress?: boolean): Observable<DeleteMealCommandResult>;
    public mealsUidDelete(uid: string, body?: DeleteMealCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteMealCommandResult>>;
    public mealsUidDelete(uid: string, body?: DeleteMealCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteMealCommandResult>>;
    public mealsUidDelete(uid: string, body?: DeleteMealCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling mealsUidDelete.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<DeleteMealCommandResult>('delete',`${this.basePath}/Meals/${encodeURIComponent(String(uid))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get single meal
     * UserUid gets sinlge meal by MealUid
     * @param uid 
     * @param mealUid 
     * @param isPreview 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mealsUidGet(uid: string, mealUid?: string, isPreview?: boolean, observe?: 'body', reportProgress?: boolean): Observable<GetMealQueryResult>;
    public mealsUidGet(uid: string, mealUid?: string, isPreview?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetMealQueryResult>>;
    public mealsUidGet(uid: string, mealUid?: string, isPreview?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetMealQueryResult>>;
    public mealsUidGet(uid: string, mealUid?: string, isPreview?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling mealsUidGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (mealUid !== undefined && mealUid !== null) {
            queryParameters = queryParameters.set('MealUid', <any>mealUid);
        }
        if (isPreview !== undefined && isPreview !== null) {
            queryParameters = queryParameters.set('IsPreview', <any>isPreview);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetMealQueryResult>('get',`${this.basePath}/Meals/${encodeURIComponent(String(uid))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates meal with provided information
     * Updates meal
     * @param uid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mealsUidPut(uid: string, body?: UpdateMealCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public mealsUidPut(uid: string, body?: UpdateMealCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public mealsUidPut(uid: string, body?: UpdateMealCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public mealsUidPut(uid: string, body?: UpdateMealCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling mealsUidPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/Meals/${encodeURIComponent(String(uid))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
